import styled from 'styled-components';

export const BasesContainer = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  position: relative;
  top: 4px;
  width: 50px;
`;

export const Base = styled.div`
  background-color: #262626;
  height: 20px;
  position: absolute;
  transform: rotate(45deg);
  width: 20px;
`;

export const BaseInside = styled.div`
  background-color: #ef7106;
  height: 14px;
  position: absolute;
  top: 3px;
  right: 3px;
  width: 14px;
`;

export const BaseLeft = styled(Base)`
  left: -4px;
  top: 30px;
  transform: translateY(-50%) rotate(45deg);
`;

export const BaseRight = styled(Base)`
  right: -4px;
  top: 30px;
  transform: translateY(-50%) rotate(45deg);
`;

export const BaseTop = styled(Base)`
  left: 25px;
  top: 0;
  transform: translateX(-50%) rotate(45deg);
`;

export const BasesOutsContainer = styled.div`
  align-items: center;
  background-color: #ccc;
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 0 20px;
`;
BasesOutsContainer.displayName = 'BasesOutsContainer';

export const Container = styled.section`
  display: flex;
  font-family: 'Gotham XNarrow', system-ui;
  font-size: 35px;
  font-weight: bold;
`;
Container.displayName = 'Container';

export const Count = styled.div`
  align-items: center;
  font-size: 32px;
  line-height: 32px;
  justify-content: center;
`;
Count.displayName = 'Count';

export const Inning = styled.div`
  align-items: center;
  background-color: #ebebeb;
  color: #000;
  display: flex;
  font-size: 40px;
  height: 100%;
  justify-content: space-evenly;
  min-width: 96px;
`;
Inning.displayName = 'Inning';

export const InningArrows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
InningArrows.displayName = 'InningArrows';

export const NumbersContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
NumbersContainer.displayName = 'NumbersContainer';

export const NumbersBottomContainer = styled.div`
  align-items: center;
  justify-content: space-around;
  background-color: #a9abad;
  color: #000;
  display: flex;
`;
NumbersBottomContainer.displayName = 'NumbersBottomContainer';

export const NumbersTopContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;
NumbersTopContainer.displayName = 'NumbersTopContainer';

export const Outs = styled.div`
  display: flex;
  margin-right: 12px;
`;
Outs.displayName = 'Outs';

export const Out = styled.div`
  background-color: ${({ active }) => (active ? '#ef7106' : '#a9abad')};
  border-radius: 50%;
  border: 4px solid #000;
  height: 22px;
  margin: 0 4px;
  width: 22px;
`;

export const Points = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  color: #fff;
  display: flex;
  font-size: 76px;
  height: 100%;
  justify-content: center;
  min-width: 99px;
  padding-top: 10px;
  text-align: center;
  text-shadow: 2px 2px 4px black;
`;
Points.displayName = 'Points';

export const TeamContainer = styled.div`
  align-items: center;
  display: flex;
  min-width: 198px;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamImage = styled.img`
  height: 88px;
`;
TeamImage.displayName = 'TeamImage';

export const TeamImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;
TeamImageContainer.displayName = 'TeamImageContainer';

export const Wrapper = styled.div`
  border-bottom: 3px solid #000;
  border-top: 3px solid #000;
  display: flex;
  height: 105px;
`;
Wrapper.displayName = 'Wrapper';
